import { translate } from '../../../../../common/i18n';

Blockly.Blocks.actual_virtual_step = {
    init: function init() {
        this.appendDummyInput().appendField(translate('Actual Virtual Step Count'));
        this.setOutput(true, 'Number');
        this.setColour('#f2f2f2');
        this.setTooltip(translate('Return the actual virtual step'));
    },
    onchange: function onchange() {},
};

Blockly.JavaScript.actual_virtual_step = () => ['BinaryBotPrivateVirtualSettings.steps + 1'];
